export enum EKeyInitiativeOutcomeValueType {
  Financial = 'Financial',
  Number = 'Number',
  Percentage = 'Percentage',
  FreeText = 'Free text',
}

export type TKeyInitiativeOutcomeItemValue = string | number | null

export interface IKeyInitiativeOutcomeItem {
  name: string
  valueType: EKeyInitiativeOutcomeValueType
  value: TKeyInitiativeOutcomeItemValue
}
